export const REDIRECTS = {
  "/partenaires": "/comparatif-assurance-decennale",
  "/metiers/poseur-revetements-souples": "/metiers/revetements-souples",
  "/metiers/specialiste-isolation": "/metiers/isolation",
  "/metiers/isolation-exterieur": "/metiers/isolation-exterieure",
  "/decennale-macon": "/metiers/macon",
  "/decennale-plombier": "/metiers/plombier",
  "/decennale-electricien": "/metiers/electricien",
  "/decennale-couvreur": "/metiers/couvreur",
  "/decennale-peintre": "/metiers/peintre",
  "/decennale-carreleur": "/metiers/carreleur",
  "/decennale-plaquiste": "/metiers/platrier-plaquiste",
  "/decennale-menuisier": "/metiers/menuisier-exterieur",
  "/decennale-chauffagiste": "/metiers/chauffagiste-climaticien",
  "/decennale-terrassier": "/metiers/terrassier",
  "/decennale-facadier": "/metiers/facadier",
  "/prix-assurance-decennale": "/prix",
  "/politique-confidentialite": "/confidentialite",
};
